<span class="text"> {{ label }} </span>
<div class="ng-content">
  <ng-content></ng-content>
</div>
